import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Segnala questa pagina',
  title: 'Segnala un problema in questa pagina',
  reasons: {
    'inaccurate-or-fabricated': 'Informazioni inesatte o inventate',
    'wrong-product': 'I prodotti non corrispondono alla pagina',
    'sexually-explicit': 'Contenuti sessualmente espliciti',
    'regulated-product': 'Prodotto soggetto a prescrizione o regolamentato',
    'dangerous-product': 'Prodotto pericoloso',
    'ip-infringement': 'Viola i miei diritti (marchio/diritto d’autore)',
    other: 'Altro',
  },
  detail: 'Dettagli (facoltativo)',
  submit: 'Invia la segnalazione',
  cancel: 'Annulla',
  sent: 'Grazie. Esaminiamo le segnalazioni entro 24 ore.',
  failed: 'Impossibile inviare la segnalazione. Riprova.',
};
